module.exports = __webpack_public_path__ + "img/puzzle.dc29751d.png";